/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ResolutionTimeAliases {
  AUTOCOMPLETE_MONTH = 'autocomplete-month',
  AUTOCOMPLETE_YEAR = 'autocomplete-year',
  CHART_TAB = 'chart-tab',
  CHART_TAB_CONTROL = 'chart-tab-control',
  CHART_TAB_CONTROL_DEFEITO = 'chart-tab-control-defeito',
  CHART_TAB_CONTROL_DUVIDA = 'chart-tab-control-duvida',
  CHART_TAB_CONTROL_SOLICITACAO = 'chart-tab-control-solicitacao',
  CHART_TAB_CONTROL_SUGESTAO = 'chart-tab-control-sugestao',
  CHART_TAB_DEFEITO = 'chart-tab-defeito',
  CHART_TAB_DUVIDA = 'chart-tab-duvida',
  CHART_TAB_SOLICITACAO = 'chart-tab-solicitacao',
  CHART_TAB_SUGESTAO = 'chart-tab-sugestao',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_MONTH = 'fetch-month',
  FETCH_MONTH_DEFEITO = 'fetch-month-defeito',
  FETCH_MONTH_DUVIDA = 'fetch-month-duvida',
  FETCH_MONTH_SOLICITACAO = 'fetch-month-solicitacao',
  FETCH_MONTH_SUGESTAO = 'fetch-month-sugestao',
  FETCH_SEARCH_LAST_SYNC = 'fetch-search-last-sync',
  FETCH_YEAR = 'fetch-year',
  FIELD_MONTH = 'field-month',
  FIELD_SEARCH_LAST_SYNC = 'field-search-last-sync',
  FIELD_YEAR = 'field-year',
  FILTER_0 = 'filter-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_DEFEITO = 'layout-defeito',
  LAYOUT_DUVIDA = 'layout-duvida',
  LAYOUT_SOLICITACAO = 'layout-solicitacao',
  LAYOUT_SUGESTAO = 'layout-sugestao',
  MAIN_COMPOSED_CHART = 'main-composed-chart',
  MAIN_COMPOSED_CHART_DEFEITO = 'main-composed-chart-defeito',
  MAIN_COMPOSED_CHART_DUVIDA = 'main-composed-chart-duvida',
  MAIN_COMPOSED_CHART_SOLICITACAO = 'main-composed-chart-solicitacao',
  MAIN_COMPOSED_CHART_SUGESTAO = 'main-composed-chart-sugestao',
  MAPPER_MONTH = 'mapper-month',
  MAPPER_SEARCH_LAST_SYNC = 'mapper-search-last-sync',
  MAPPER_YEAR = 'mapper-year',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2_DEFEITO = 'panel-2-defeito',
  PANEL_2_DUVIDA = 'panel-2-duvida',
  PANEL_2_SOLICITACAO = 'panel-2-solicitacao',
  PANEL_2_SUGESTAO = 'panel-2-sugestao',
  PANEL_3 = 'panel-3',
  PANEL_DEFEITO = 'panel-defeito',
  PANEL_DUVIDA = 'panel-duvida',
  PANEL_GRAPHIC = 'panel-graphic',
  PANEL_GRAPHIC_DEFEITO = 'panel-graphic-defeito',
  PANEL_GRAPHIC_DUVIDA = 'panel-graphic-duvida',
  PANEL_GRAPHIC_SOLICITACAO = 'panel-graphic-solicitacao',
  PANEL_GRAPHIC_SUGESTAO = 'panel-graphic-sugestao',
  PANEL_SOLICITACAO = 'panel-solicitacao',
  PANEL_SUGESTAO = 'panel-sugestao',
  PANEL_TITULO_CARD = 'panel-titulo-card',
  TABLE_COLUMN_0 = 'table-column-0',
  TABLE_COLUMN_0_DEFEITO = 'table-column-0-defeito',
  TABLE_COLUMN_0_DUVIDA = 'table-column-0-duvida',
  TABLE_COLUMN_0_SOLICITACAO = 'table-column-0-solicitacao',
  TABLE_COLUMN_0_SUGESTAO = 'table-column-0-sugestao',
  TABLE_COLUMN_1 = 'table-column-1',
  TABLE_COLUMN_1_DEFEITO = 'table-column-1-defeito',
  TABLE_COLUMN_1_DUVIDA = 'table-column-1-duvida',
  TABLE_COLUMN_1_SOLICITACAO = 'table-column-1-solicitacao',
  TABLE_COLUMN_1_SUGESTAO = 'table-column-1-sugestao',
  TABLE_COLUMN_2_DEFEITO = 'table-column-2-defeito',
  TABLE_COLUMN_2_DUVIDA = 'table-column-2-duvida',
  TABLE_COLUMN_2_SOLICITACAO = 'table-column-2-solicitacao',
  TABLE_COLUMN_2_SUGESTAO = 'table-column-2-sugestao',
  TABLE_MONTH = 'table-month',
  TABLE_MONTH_DEFEITO = 'table-month-defeito',
  TABLE_MONTH_DUVIDA = 'table-month-duvida',
  TABLE_MONTH_SOLICITACAO = 'table-month-solicitacao',
  TABLE_MONTH_SUGESTAO = 'table-month-sugestao',
  TEXT_2_DEFEITO = 'text-2-defeito',
  TEXT_2_DUVIDA = 'text-2-duvida',
  TEXT_2_SOLICITACAO = 'text-2-solicitacao',
  TEXT_2_SUGESTAO = 'text-2-sugestao',
  TEXT_CARD = 'text-card',
  TEXT_MONTH = 'text-month',
  TEXT_SEARCH_LAST_SYNC = 'text-search-last-sync',
  TEXT_YEAR = 'text-year',
}
export { ResolutionTimeAliases };
